import React from "react";
import SharedMoneyCalculator from "../../components/sharedMoney/SharedMoneyCalculator";

const SharedMoney: React.FC = () => {
  return <SharedMoneyCalculator />;
};

export default SharedMoney;
